export const getEmptyOtp = (): string[] => ['', '', '', '', '', ''];
